module.exports = __webpack_public_path__ + "img/Aspects-Sources.c3cbf256.svg";